import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'
import { parseRmaReasonDTO, RmaReasonDTO } from 'components/ordering/rma/api/dtos/rma-reason-dto.js'


export type IRmaLineDTO = {
  id: string
  product_code: string
  oem: string | null
  ean: string | null
  product_id: number
  product_name: string
  image_url: string
  shipment_date: string | null
  sale_reference: string | null
  saleID: string | null
  erp_order_number: string | null
  customer_order_nr: string | null
  shipment_reference: string | null
  shipmentID: string | null
  shipped_quantity: number
  memo: string | null
  memo2: string | null
  memo3: string | null
  quantity: number
  quantity_confirmed: number
  service_response_text: string | null
  reason: string
  reasons: unknown
  originMove: number | null
  pictures: { name: string; identifier: string }[]
  rma_allowed: boolean
}


export class RmaLineDTO {
  id: string
  productCode: string
  oem: string | null
  ean: string | null
  productId: number
  productName: string
  imageUrl: string
  shipmentDate: string | null
  saleReference: string | null
  saleId: string | null
  erpOrderNumber: string | null
  customerOrderNr: string | null
  shipmentReference: string | null
  shipmentId: string | null
  shippedQuantity: number
  memo: string | null
  memo2: string | null
  memo3: string | null
  quantity: number
  quantityConfirmed: number
  serviceResponseText: string | null
  reason: string
  reasons: RmaReasonDTO[]
  originMove: number | null
  pictures: { name: string; identifier: string }[]
  rmaAllowed: boolean

  constructor(data: IRmaLineDTO) {
    this.id = data.id
    this.productCode = data.product_code
    this.oem = data.oem
    this.ean = data.ean
    this.productId = data.product_id
    this.productName = data.product_name
    this.imageUrl = data.image_url
    this.shipmentDate = data.shipment_date
    this.saleReference = data.sale_reference
    this.saleId = data.saleID
    this.erpOrderNumber = data.erp_order_number
    this.customerOrderNr = data.customer_order_nr
    this.shipmentReference = data.shipment_reference
    this.shipmentId = data.shipmentID
    this.shippedQuantity = data.shipped_quantity
    this.memo = data.memo
    this.memo2 = data.memo2
    this.memo3 = data.memo3
    this.quantity = data.quantity
    this.quantityConfirmed = data.quantity_confirmed
    this.serviceResponseText = data.service_response_text
    this.reason = data.reason
    this.reasons = (data.reasons as unknown[]).map(parseRmaReasonDTO)
    this.originMove = data.originMove
    this.pictures = data.pictures
    this.rmaAllowed = data.rma_allowed
  }
}


const validate = createValidate<IRmaLineDTO>()

export const parseRmaLineDTO = (data: unknown): RmaLineDTO => {
  validateGuard(validate, data, 'rma line')
  return new RmaLineDTO(data)
}
